import { clsx } from "clsx";

import type { ContainerVariantType } from "../../../RVFlowTypes";

import styles from "./BlockContainer.module.scss";

type BlockContainerProps = {
    isDisabled?: boolean;
    icon?: JSX.Element;
    children: JSX.Element | JSX.Element[];
    iconClassName?: string;
    contentClassName?: string;
    variant?: ContainerVariantType;
};

export function BlockContainer({
    isDisabled,
    icon,
    children,
    iconClassName,
    contentClassName,
    variant,
}: BlockContainerProps): JSX.Element {
    return (
        <div
            className={clsx(styles.container, variant, {
                [styles.disabled]: isDisabled,
            })}
        >
            {icon && (
                <div className={clsx(styles.iconBox, "flex-row align-center justify-center", iconClassName)}>
                    {icon}
                </div>
            )}
            <div className={clsx(styles.contentBox, "flex-column", contentClassName)}>{children}</div>
        </div>
    );
}
